<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Relatório de Disponibilidade de Vagas</h2>
                    </div>
                </div>

                <div class="panel-body">

                    <form [formGroup]="formularioDeDisponibilidadeDeVagas" (ngSubmit)="onSubmit()">

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-12 col-12">
                                <mat-label>Filial</mat-label>
                                <mat-select value="Filial" formControlName="filial" name="filial" id="filial" required>
                                    <mat-option *ngFor="let filial of listaFiliais" [value]="filial">
                                        {{filial.nome}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formularioDeDisponibilidadeDeVagas.controls.filial.hasError('required')">
                                    O campo Filial é obrigatório.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-12 col-12">
                                <mat-label>Data Inicial e Final</mat-label>

                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate placeholder="Data Inicial" formControlName="dataInicial"
                                        required>
                                    <input matEndDate placeholder="Data Final" formControlName="dataFinal"
                                        required>
                                </mat-date-range-input>

                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>

                                <mat-error
                                    *ngIf="formularioDeDisponibilidadeDeVagas.controls.dataInicial.hasError('invalidDate') || formularioDeDisponibilidadeDeVagas.controls.dataFinal.hasError('invalidDate')">
                                    Datas inválidas ou com intervalos não permitidos.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                                <mat-label>Consultas</mat-label>
                                <mat-select formControlName="procedimentos" name="procedimentos" id="procedimentos"
                                    multiple>
                                    <mat-select-trigger>
                                        {{(controlProcedimentos.value && controlProcedimentos.value[0]) ? controlProcedimentos.value[0].nome : ''}}
                                        <span *ngIf="controlProcedimentos.value?.length > 1"
                                            class="example-additional-selection">
                                            (+{{controlProcedimentos.value.length - 1}}
                                            {{controlProcedimentos.value?.length === 2 ? 'outro' :
                                            'outros'}})
                                        </span>
                                    </mat-select-trigger>
                                    <mat-option *ngFor="let procedimentoConsulta of listaDeProcedimentoConsulta"
                                        [value]="procedimentoConsulta">
                                        {{procedimentoConsulta.nome}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formularioDeDisponibilidadeDeVagas.controls.procedimentos.hasError('required')">
                                    Selecione pelo menos uma Consulta.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                                <mat-label>Agrupar por</mat-label>
                                <mat-select value="Agrupar por" formControlName="codTipoAgrupamento"
                                    name="codTipoAgrupamento" id="codTipoAgrupamento">
                                    <mat-option
                                        *ngFor="let tipoAgrupamento of listaTipoAgrupamentoDisponibilidadeDeVagasParaConsulta"
                                        [value]="tipoAgrupamento.codigo">
                                        {{tipoAgrupamento.descricao}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formularioDeDisponibilidadeDeVagas.controls.codTipoAgrupamento.hasError('required')">
                                    O campo Agrupar por é obrigatório.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-lg-12 col-md-12 col-sm-12 col-12" style="align-self: center;">
                                <button mat-raised-button color="success" type="submit" matTooltip="Consultar"
                                    [disabled]="!formularioDeDisponibilidadeDeVagas.valid" style="width: 100%;">
                                    Consultar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>